import { call, fork, put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureUpdateContextDataSuccessAction } from '../actions';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
import { PhotoCaptureContextService } from '../services';
import { intelligentPhotoCaptureFailureLoggingSaga } from './intelligentPhotoCaptureFailureLoggingSaga';
export function* photoCaptureUpdateContextSaga(action, photoCaptureContextService = new PhotoCaptureContextService()) {
    const { contextDataUpdateInput, contextId, coCode, selectedShopIdByUser, isShopUpdatedByUser } = action.payload;
    try {
        yield call({
            context: photoCaptureContextService,
            fn: photoCaptureContextService.photoCaptureUpdateContextData
        }, contextDataUpdateInput, contextId, coCode, selectedShopIdByUser, isShopUpdatedByUser);
        yield put(photoCaptureUpdateContextDataSuccessAction(selectedShopIdByUser, isShopUpdatedByUser));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        // Fire-and-forget error logging so catch-path handling is not blocked.
        yield fork(intelligentPhotoCaptureFailureLoggingSaga, {
            actionType: action.type,
            response: error,
            requestedPayload: action.payload,
            companyCode: coCode,
            errorDetail: errorMessage
        });
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=photoCaptureUpdateContextSaga.js.map